import * as BABYLON from "babylonjs";
import config from "../config";
import { copymesh,meshIns, worldToScreen } from "../Tools/index.js";
import {  productinLayout } from "../Tools/layout";
import { meshA, meshHide } from "../Animate";
import { meshoutline,meshInsMouseIn } from "../Tools/mesheffect";
export class ProductIn {
  constructor(type) {
    if (!ProductIn[type]) {
      ProductIn[type] = this;
      this.type =  type
      this.cfg = config[type]
      this.init(type)
    }
    return ProductIn[type];

  }

  init(type){
    levelsShowIns.loader.cache[type + "in.glb"].addAllToScene()
    this.rootmesh = levelsShowIns.loader.cache[type + "in.glb"].meshes[0]
    this.meshs = [...levelsShowIns.loader.cache[type + "in.glb"].meshes]
    this.rootmesh.position.y = config.table.height
    this.rootmesh.scaling.x = config.scal
    this.rootmesh.scaling.y = config.scal
    this.rootmesh.scaling.z = config.scal
    this.setA(1.0)
    this.addcu()

  }
  addcu(){
    // let layout = this.type //形成每一簇的布局
    this.models = []
    this.hotpois = []
    let productcfg = {}
    let layoutconfig =  productinLayout(this.cfg, this.type,config)
    this.layoutconfig = layoutconfig

    // add models
    for (let index = 0; index < layoutconfig.models.length; index++) {
      let modeinfo = layoutconfig.models[index];
      //copymesh meshIns
      let mesh = meshIns(
        levelsShowIns.loader.cache[modeinfo.tpye + ".glb"].meshes[0],
        // levelsShowIns.loader.cache[modeinfo.tpye + ".glb"].meshes[1],
        modeinfo.id,this.rootmesh
      );
      mesh.id = modeinfo.id
      mesh.name = modeinfo.id
      mesh.$modeinfo = modeinfo
      mesh.rotation.y = modeinfo.r
      this.addModelAction(mesh.getChildMeshes()[0])
      this.models.push(mesh)
      this.rootmesh.addChild(mesh)
      mesh.position.x = modeinfo.poi[0]
      mesh.position.y = modeinfo.poi[1]
      mesh.position.z = modeinfo.poi[2]
      mesh.scaling.x = 1
      mesh.scaling.y = 1
      mesh.scaling.z = 1
      //设置颜色变红
      //this.setWarnColor(mesh)
    }
  }
  //获取簇编号
  getCuNumber(mesh){
    let ids = mesh.id.split('_')
    return {id:ids[4]*2+parseInt(ids[5]),clu:parseInt(ids[2])+1}
  }
  //设置产品告警红色
  setWarnColor(mesh){
    let position = [];
    let alarm = levelsShowIns.projectInfo.alarm
    //告警过滤
    if (alarm.length) {
      alarm.forEach(item => {
        if (item.positions.length > 0) {
          position = [...item.positions];
        }
      });
    }
    position.forEach(item=>{
      if(item.box){
        let box = item.box
        let clu = item.clu
        // console.log(box,mesh.$modeinfo.name ,clu,mesh.$modeinfo.cu.cluName)
        if(box==mesh.$modeinfo.name && clu==mesh.$modeinfo.cu.cluName){
          mesh.instancedBuffers.color = BABYLON.Color3.Red()
        }
      }
    })
  }
  addModelAction(mesh){
    mesh.actionManager = new BABYLON.ActionManager(levelsShowIns.scene);
    mesh.actionManager.registerAction(
      new BABYLON.ExecuteCodeAction(
        BABYLON.ActionManager.OnPointerOverTrigger,
        e => {
          // meshoutline(mesh, true);
          meshInsMouseIn(mesh,true)
          levelsShowIns.poplabel(mesh);
        }
      )
    );
    mesh.actionManager.registerAction(
      new BABYLON.ExecuteCodeAction(
        BABYLON.ActionManager.OnPointerOutTrigger,
        e => {
          meshInsMouseIn(mesh,false)
          // mesh.renderOutline = false;
          levelsShowIns.poplabel();
        }
      )
    );
    mesh.actionManager.registerAction(
      new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, async e => {

        // worldToScreen
        var res = worldToScreen(
          mesh.getBoundingInfo().boundingBox.centerWorld,
          levelsShowIns.camera,
          levelsShowIns.scene,
          levelsShowIns.engine
        );
        let poi = {
          l : res._x,
          t : res._y,
        }
        // window.$vm.$router.push('/model/'+mesh.id)
        window.$vm.$router.push(`/svolt/project?projectId=${levelsShowIns.activeProject.projectInfo.id}`)
        // window.$vm.$router.push(`/svolt/project?projectId=${levelsShowIns.activeProject.projectInfo.id}&appid=cellMonitoring`)
        // http://svolt-ess-frontend-dev.svoltems.cn/#/svolt/project?projectId=86-072550-001&appid=cellMonitoring
        // levelsShowIns.eventbus.$emit('modelclick',{mesh,poi});
      })
    );
  }
  setA(num){
    for (let index = 0; index < this.meshs.length; index++) {
      this.meshs[index].visibility = num;
    }
  }
  switchModelsVisibe(productId){

  }
  switchModelsStatus(productId){

  }
  show(mesh){
    let cus = mesh.$objinfo.meta.cus
    // console.log(mesh,cus)
    // mesh.$objinfo.meta.models
    this.lastmesh = mesh
    this.rootmesh.position.x = mesh.absolutePosition._x
    this.rootmesh.position.y = mesh.absolutePosition._y
    this.rootmesh.position.z = mesh.absolutePosition._z

    // console.log(5,new Date().getTime());
    // this.centerWorld = this.rootmesh.getBoundingInfo().boundingSphere.centerWorld
     //add cu hot poi
     this.hotpois = []

     for (let index = 0; index < this.layoutconfig.cushot.length; index++) {
      const hot = this.layoutconfig.cushot[index];
      let hotpoi = [ mesh.absolutePosition._x +hot.x, mesh.absolutePosition._y +hot.y , mesh.absolutePosition._z +hot.z,]
      let point = new BABYLON.Vector3(...hotpoi);
      let hotshow = false
      let name
      try {
        hotshow = mesh.$objinfo.meta.cus[index].show
        name = mesh.$objinfo.meta.cus[index].name
      } catch (error) {

      }
      this.hotpois.push({id:hot.id,point,index:hot.index,show:hotshow,name})
    }
    levelsShowIns.activeIn = this
    // levelsShowIns.scene.registerBeforeRender(this.addHotPoi);
    levelsShowIns.scene.registerBeforeRender(this.addCuHotPoi);
    this.setA(1.0)
    for (let index = 0; index < this.models.length; index++) {

      try {
        this.models[index].getChildMeshes()[0].$modeinfo = mesh.$objinfo.meta.models[index]
        console.log(this.models[index].getChildMeshes()[0].$modeinfo)
        // if(this.models[index].getChildMeshes()[0].$modeinfo.name=='8#插箱'){
        //   this.models[index].getChildMeshes()[0].instancedBuffers.color = BABYLON.Color3.Red()
        // }
        this.setWarnColor(this.models[index].getChildMeshes()[0])
      } catch (error) {}
      let isShow = false
      try {
        isShow = mesh.$objinfo.meta.models[index].show
      } catch (error) {}
      // hideindex
      if (isShow) {
        this.setModelA(this.models[index],1)
      }else{
        this.setModelA(this.models[index],0)
      }

      // this.models[index].visibility = 1.0;
      this.models[index].getChildMeshes()[0].isPickable = true

      //
    }
    if(config[mesh.$type].cu.bigcu.length==1){

    }else{
      setTimeout(()=>{this.showModels();},1000)
      // this.models[index].getChildMeshes()[0].isPickable = false
    }
    // console.log(6,new Date().getTime());
  }
  setModelA(model,visible){
    let insMeshs = model.getChildMeshes()
    for (let index = 0; index < insMeshs.length; index++) {
      insMeshs[index].isVisible = visible
    }
  }
  showModels(){
    levelsShowIns.eventbus.$emit('levelchange', 4);
    for (let index = 0; index < this.models.length; index++) {
      let model  = this.models[index];
      this.models[index].getChildMeshes()[0].isPickable = true
      if(model.$modeinfo._bigcu !== 0){
        if(!model.$stat){
          meshA(model,levelsShowIns.scene,'position.z',model.position.z,model.$modeinfo.poi[2] + 2)
          let submodels = model.getChildMeshes()
          for (let i = 0; i < submodels.length; i++) {
            submodels[i].rotation.y = Math.PI
          }
        }
      }else{
        if(!model.$stat){
          meshA(model,levelsShowIns.scene,'position.y',model.position.y,model.$modeinfo.poi[1] +3)
        }
      }
      model.$stat = 1
    }
    for (let j = 0; j < this.hotpois.length; j++) {
      if( !!this.hotpois[j].index){
        this.hotpois[j].point._z += 2.0
      }else{
        this.hotpois[j].point._y += 3.0
      }
    }
  }
  hideModels(){
    levelsShowIns.eventbus.$emit('levelchange', 2);
    for (let index = 0; index < this.models.length; index++) {
      let model  = this.models[index];
      this.models[index].getChildMeshes()[0].isPickable = false
      if(model.$modeinfo._bigcu !== 0){
        if(model.$stat){
          meshA(model,levelsShowIns.scene,'position.z',model.position.z,model.$modeinfo.poi[2])
          let submodels = model.getChildMeshes()
          for (let i = 0; i < submodels.length; i++) {
            submodels[i].rotation.y = 0
          }
        }
      }else{
        if(model.$stat)meshA(model,levelsShowIns.scene,'position.y',model.position.y,model.$modeinfo.poi[1])
      }
      model.$stat = 0
    }
    for (let j = 0; j < this.hotpois.length; j++) {
      if( !!this.hotpois[j].index){
        this.hotpois[j].point._z -= 2.0
      }else{
        this.hotpois[j].point._y -= 3.0
      }
    }
  }

  addCuHotPoi(){
    try {
    let cw = levelsShowIns.activeIn.centerWorld
    let hotpois = levelsShowIns.activeIn.hotpois
    let layoutconfig = levelsShowIns.activeIn.layoutconfig
    let pois = []
    for (let index = 0; index < hotpois.length; index++) {
      if(hotpois[index].show){
        let point = hotpois[index];
        let res = worldToScreen(
          point.point,
          levelsShowIns.camera,
          levelsShowIns.scene,
          levelsShowIns.engine
        );
        let poi={}
        poi.show = res._z < 1 ? true : false;
        poi.s = res._z;
        poi.left = res._x;
        poi.top = res._y;
        poi.name = point.name
        poi.isBattery = 0
        pois.push(poi)
      }
      continue
    }
    // { show: true, left: 30, top: 30, s: 1, name: "data2" ,isBattery:0},
    levelsShowIns.eventbus.$emit('inpois', pois);
    } catch (error) {
    }
  }
  addHotPoi() {
    let cw = levelsShowIns.activeIn.centerWorld
    let cfg = levelsShowIns.activeIn.cfg
    let pois = cfg.hotpoi
    // hotpoi: [
    //   {name:'EMS', isBattery:false,x: 0, y: 0, z: 2.4383 * scal/2},
    //   {name:'PCS', isBattery:false,x: 0.3, y: 0, z: 2.4383 * scal/2},
    //   {name:'空调',isBattery:false,x: 0.2, y: 0, z: 2.4383 * scal/2},
    //   // {name:'储能电池',isBattery:1,x: 0.1, y: 0, z: 2.4383 * scal/2},
    // ]
    for (let index = 0; index < pois.length; index++) {
      let poi = pois[index];
      let hotpoi = [cw._x + poi.x,cw._y + poi.y,cw._z + poi.z,]
      let point = new BABYLON.Vector3(...hotpoi);
      let res = worldToScreen(
        point,
        levelsShowIns.camera,
        levelsShowIns.scene,
        levelsShowIns.engine
      );
      poi.show = res._z < 1 ? true : false;
      poi.s = res._z;
      poi.left = res._x;
      poi.top = res._y;
    }

    levelsShowIns.eventbus.$emit('inpois', pois);
  }
  hide() {
    levelsShowIns.scene.unregisterBeforeRender(this.addCuHotPoi);
    levelsShowIns.eventbus.$emit('inpois', []);
    this.lastmesh.isPickable = true
    this.lastmesh = null
    this.setA(0.0)
    for (let index = 0; index < this.models.length; index++) {
      this.setModelA(this.models[index],0)
      // this.models[index].visibility = 0.0;
      // this.models[index].isPickable = false
    }
    this.hideModels()
  }
}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Object/ProductIn.js